'use client';

import Link from 'next/link';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';
import { AppButton } from '@/components/common';

/**
 * 404 Not Found 페이지
 * 존재하지 않는 경로에 접근했을 때 표시됩니다.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* 아이콘 */}
        <div className="flex justify-center">
          <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center">
            <FileQuestion className="w-10 h-10 text-purple-600" />
          </div>
        </div>

        {/* 404 표시 */}
        <div className="space-y-2">
          <p className="text-6xl font-bold text-purple-600">404</p>
          <h1 className="heading-2 text-neutral-900">
            페이지를 찾을 수 없습니다
          </h1>
          <p className="body-base text-neutral-600">
            요청하신 페이지가 존재하지 않거나,
            이동되었을 수 있습니다.
          </p>
        </div>

        {/* 액션 버튼 */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/">
            <AppButton variant="primary" className="flex items-center gap-2 w-full sm:w-auto">
              <Home className="w-4 h-4" />
              홈으로 이동
            </AppButton>
          </Link>
          <AppButton
            onClick={() => window.history.back()}
            variant="outline"
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            이전 페이지
          </AppButton>
        </div>

        {/* 유용한 링크 */}
        <div className="pt-4 border-t border-neutral-200">
          <p className="body-small text-neutral-500 mb-3">
            다음 페이지가 도움이 될 수 있습니다:
          </p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link href="/dashboard" className="text-sm text-purple-600 hover:underline">
              대시보드
            </Link>
            <span className="text-neutral-300">•</span>
            <Link href="/playlists" className="text-sm text-purple-600 hover:underline">
              플레이리스트
            </Link>
            <span className="text-neutral-300">•</span>
            <Link href="/tracks" className="text-sm text-purple-600 hover:underline">
              트랙
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
